export const getDeviceAuthToken = (): string => {
  let deviceAuthToken = window.localStorage.getItem('deviceAuthToken');
  if (!deviceAuthToken) {
    deviceAuthToken = Array.from(crypto.getRandomValues(new Uint8Array(32)))
      .map((byte) => byte.toString(16).padStart(2, '0'))
      .join('');
    window.localStorage.setItem('deviceAuthToken', deviceAuthToken);
  }
  return deviceAuthToken;
};

export const copyDeviceAuthURL = (deviceAuthToken: string) => {
  const el = document.createElement('textarea');
  el.value = `https://insights.talka.ai/auth-zoom-app?device-auth-token=${deviceAuthToken}`;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};
